var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-alert", { attrs: { variant: "secondary", show: "" } }, [
        _c("div", { staticClass: "alert-body" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t(
                  'Por padrão, todos os dias seguem a Configuração base. Ative "Personalizar" em um dia para definir horário, taxa por KM ou faixas diferentes apenas nele.'
                )
              ) +
              " "
          ),
        ]),
      ]),
      _c(
        "b-card",
        {
          staticClass: "bg-light-secondary mb-1",
          attrs: { "body-class": "py-1" },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center mb-50" },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "AnchorIcon", size: "16" },
              }),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.$t("Padrão herdado pelos dias sem personalização"))
                ),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "mb-50", attrs: { md: "3" } }, [
                _c("small", { staticClass: "text-muted d-block" }, [
                  _vm._v(_vm._s(_vm.$t("Delivery"))),
                ]),
                _vm._v(" " + _vm._s(_vm.defaultEnabledLabel) + " "),
              ]),
              _c("b-col", { staticClass: "mb-50", attrs: { md: "3" } }, [
                _c("small", { staticClass: "text-muted d-block" }, [
                  _vm._v(_vm._s(_vm.$t("Taxa por KM"))),
                ]),
                _vm._v(" " + _vm._s(_vm.defaultPerKmLabel) + " "),
              ]),
              _c("b-col", { staticClass: "mb-50", attrs: { md: "3" } }, [
                _c("small", { staticClass: "text-muted d-block" }, [
                  _vm._v(_vm._s(_vm.$t("Valor mínimo"))),
                ]),
                _vm._v(" " + _vm._s(_vm.defaultMinOrderLabel) + " "),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt-50" },
            [
              _c("small", { staticClass: "text-muted d-block" }, [
                _vm._v(_vm._s(_vm.$t("Faixas padrão"))),
              ]),
              _vm._l(_vm.config.defaultTiers, function (tier, tIndex) {
                return _c("span", { key: tIndex, staticClass: "mr-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("A partir de")) +
                      " " +
                      _vm._s(_vm.formatCurrency(tier.productsValueFrom)) +
                      " — " +
                      _vm._s(
                        tier.value === 0
                          ? _vm.$t("grátis")
                          : _vm.formatCurrency(tier.value)
                      )
                  ),
                  tIndex < _vm.config.defaultTiers.length - 1
                    ? _c("span", [_vm._v(";")])
                    : _vm._e(),
                ])
              }),
            ],
            2
          ),
          _c("small", { staticClass: "text-muted d-block mt-50" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    'Os campos "Abre"/"Fecha" deixados em branco herdam o horário de funcionamento da loja.'
                  )
                ) +
                " "
            ),
          ]),
        ],
        1
      ),
      _vm._l(_vm.config.days, function (day) {
        return _c(
          "div",
          { key: day.dayOfWeek, staticClass: "border rounded mb-50" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center justify-content-between px-1 py-75",
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c(
                      "strong",
                      {
                        staticClass: "mr-1",
                        staticStyle: {
                          "min-width": "130px",
                          display: "inline-block",
                        },
                      },
                      [_vm._v(_vm._s(_vm.dayLabel(day.dayOfWeek)))]
                    ),
                    _c(
                      "b-badge",
                      {
                        attrs: {
                          variant: _vm.isShown(day.dayOfWeek)
                            ? "light-primary"
                            : "light-secondary",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isShown(day.dayOfWeek)
                                ? _vm.$t("Personalizado")
                                : _vm.$t("Segue o padrão")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "b-form-checkbox",
                  {
                    attrs: {
                      id: "day-" + day.dayOfWeek + "-personalize",
                      switch: "",
                      checked: _vm.isShown(day.dayOfWeek),
                    },
                    on: {
                      change: function (checked) {
                        return _vm.togglePersonalize(day, checked)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("Personalizar")) + " ")]
                ),
              ],
              1
            ),
            _c(
              "b-collapse",
              { attrs: { visible: _vm.isShown(day.dayOfWeek) } },
              [
                _c(
                  "div",
                  { staticClass: "px-1 pb-1" },
                  [
                    _c("p", { staticClass: "text-muted mb-1" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              'Campos deixados em "Herdar" continuam seguindo a Configuração base.'
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "d-block",
                                attrs: {
                                  for: "day-" + day.dayOfWeek + "-enabled",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("Delivery neste dia")))]
                            ),
                            _c("b-form-select", {
                              attrs: {
                                id: "day-" + day.dayOfWeek + "-enabled",
                                options: _vm.enabledOptions,
                              },
                              model: {
                                value: day.deliveryEnabled,
                                callback: function ($$v) {
                                  _vm.$set(day, "deliveryEnabled", $$v)
                                },
                                expression: "day.deliveryEnabled",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "day-" + day.dayOfWeek + "-start",
                                type: "text-mask",
                                mask: ["##:##"],
                                name: "day_" + day.dayOfWeek + "_start",
                                label: _vm.$t("Abre"),
                                placeholder: _vm.$t("Herdar (horário da loja)"),
                              },
                              model: {
                                value: day.deliveryStartTime,
                                callback: function ($$v) {
                                  _vm.$set(day, "deliveryStartTime", $$v)
                                },
                                expression: "day.deliveryStartTime",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "day-" + day.dayOfWeek + "-end",
                                type: "text-mask",
                                mask: ["##:##"],
                                name: "day_" + day.dayOfWeek + "_end",
                                label: _vm.$t("Fecha"),
                                placeholder: _vm.$t("Herdar (horário da loja)"),
                              },
                              model: {
                                value: day.deliveryEndTime,
                                callback: function ($$v) {
                                  _vm.$set(day, "deliveryEndTime", $$v)
                                },
                                expression: "day.deliveryEndTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.hasIncompleteWindow(day)
                      ? _c(
                          "b-row",
                          [
                            _c("b-col", [
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        'Preencha "Abre" e "Fecha" juntos, ou deixe ambos vazios para herdar o horário da loja.'
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "day-" + day.dayOfWeek + "-min-order",
                                type: "text-number",
                                filter: "currency",
                                currency: "R$",
                                precision: 2,
                                name: "day_" + day.dayOfWeek + "_min_order",
                                label: _vm.$t("Valor mínimo (R$)"),
                                placeholder: _vm.inheritMinOrderPlaceholder,
                              },
                              model: {
                                value: day.minOrderValue,
                                callback: function ($$v) {
                                  _vm.$set(day, "minOrderValue", $$v)
                                },
                                expression: "day.minOrderValue",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "3" } },
                          [
                            _c("FormulateInput", {
                              attrs: {
                                id: "day-" + day.dayOfWeek + "-fee-per-km",
                                type: "text-number",
                                filter: "currency",
                                currency: "R$",
                                precision: 2,
                                name: "day_" + day.dayOfWeek + "_fee_per_km",
                                label: _vm.$t("Taxa por KM"),
                                placeholder: _vm.inheritPerKmPlaceholder,
                              },
                              model: {
                                value: day.deliveryFeePerKilometer,
                                callback: function ($$v) {
                                  _vm.$set(day, "deliveryFeePerKilometer", $$v)
                                },
                                expression: "day.deliveryFeePerKilometer",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("hr"),
                    _vm.isInheriting(day.dayOfWeek)
                      ? _c(
                          "b-alert",
                          { attrs: { variant: "secondary", show: "" } },
                          [
                            _c("div", { staticClass: "alert-body" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "As faixas de taxa deste dia seguem as faixas padrão da base:"
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                "ul",
                                { staticClass: "mb-0 mt-50" },
                                _vm._l(
                                  _vm.config.defaultTiers,
                                  function (tier, tIndex) {
                                    return _c("li", { key: tIndex }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("A partir de")) +
                                          " " +
                                          _vm._s(
                                            _vm.formatCurrency(
                                              tier.productsValueFrom
                                            )
                                          ) +
                                          " — " +
                                          _vm._s(
                                            tier.value === 0
                                              ? _vm.$t("Frete grátis")
                                              : _vm.formatCurrency(tier.value)
                                          ) +
                                          " "
                                      ),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        )
                      : _c(
                          "b-alert",
                          { attrs: { variant: "warning", show: "" } },
                          [
                            _c("div", { staticClass: "alert-body" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "Este dia usa faixas próprias (não herda mais o padrão). A faixa a partir de R$ 0,00 é obrigatória."
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                    _c("delivery-fee-tiers", {
                      attrs: {
                        tiers: day.tiers,
                        name: "day_" + day.dayOfWeek + "_tiers",
                        label: _vm.$t("Faixas de taxa deste dia"),
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }